export default __webpack_public_path__ + "locales/lv/Errors.json?hash=10cef1e51571d6d359764d8e57ebcac0";